document.addEventListener("DOMContentLoaded", () => {

  // =========================
  // 1- MENU TOGGLE
  // =========================
  let humburger = document.querySelector(".humburger");
  let menu = document.querySelector(".bottom_header_cnt");
  let menuModal = document.querySelector(".menu_modal");

  function showMenu() {
    if (!menu || !menuModal) return;

    if (
      !menu.classList.contains("show_menu") &&
      !menuModal.classList.contains("show_modal")
    ) {
      menu.classList.add("show_menu");
      menuModal.classList.add("show_modal");

      menuModal.classList.remove("delay_modal");
    } else {
      menu.classList.remove("show_menu");
      menuModal.classList.add("delay_modal");
      menuModal.classList.remove("show_modal");
    }
  }

  if (humburger) {
    humburger.addEventListener("click", showMenu);
  }

  // =========================
  // 2- SEARCH TOGGLE
  // =========================
  document.querySelectorAll(".search_icon").forEach((item) => {
    item.addEventListener("click", function () {
      const parent = item.parentNode?.parentNode;
      if (!parent) return;

      const target = parent.children?.[1];
      if (!target) return;

      target.style.display =
        target.style.display === "block" ? "none" : "block";
    });
  });

  // =========================
  // 3- READ MORE + INLINE ADS
  // =========================

  function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  const countP = document.querySelectorAll("#echo_detail p");

  // READ MORE
  const readMore = document.getElementsByClassName("read_more")[0];
  if (readMore) {
    if (countP.length > 3) {
      insertAfter(readMore, countP[2]);
    } else {
      readMore.style.display = "none";
    }
  }

  // INLINE AD 1 (after 3rd paragraph)
  const ad1 = document.getElementById("inline_zxc_1");
  if (ad1) {
    if (countP.length > 3) {
      insertAfter(ad1, countP[2]);
    } else {
      ad1.style.display = "none";
    }
  }

  // INLINE AD 2 (after 1st paragraph)
  const ad2 = document.getElementById("first_inline_zxc");

  if (ad2) {
    if (countP.length > 0) {
      insertAfter(ad2, countP[0]);
    } else {
      ad2.style.display = "none";
    }
  }

  // =========================
  // 4- RATE SYSTEM
  // =========================
  if (typeof newsMasterIdForRate !== "undefined") {

    const plusBtn = document.getElementById("plusme");
    const minusBtn = document.getElementById("minusme");

    if (plusBtn) {
      plusBtn.addEventListener("click", function () {
        fetch("/rates/score/?type=%2B&object_master_id=" + newsMasterIdForRate)
          .then((res) => res.json())
          .then((newScore) => {
            updateRateUI(newScore);
          })
          .catch(() => {
            const err = document.getElementById("ifError");
            if (err) err.innerHTML = "خطا در ارتباط با سرور";
          });
      });
    }

    if (minusBtn) {
      minusBtn.addEventListener("click", function () {
        fetch("/rates/score/?type=%2D&object_master_id=" + newsMasterIdForRate)
          .then((res) => res.json())
          .then((newScore) => {
            updateRateUI(newScore);
          })
          .catch(() => {
            const err = document.getElementById("ifError");
            if (err) err.innerHTML = "خطا در ارتباط با سرور";
          });
      });
    }

    function updateRateUI(newScore) {
      const totalPlus = newScore.plus * 5;
      const totalNumScore = Number(newScore.plus) + Number(newScore.minus);
      const percentRate =
        totalNumScore > 0
          ? ((totalPlus + Number(newScore.minus)) * 100) /
            (totalNumScore * 5)
          : 0;

      const star = document.querySelector(".front-stars");
      if (star) {
        star.style.width = percentRate < 0 ? "0%" : percentRate + "%";
      }

      const plusEl = document.getElementById("addPlus");
      const minusEl = document.getElementById("addMinus");

      if (plusEl) plusEl.innerHTML = "<span>" + newScore.plus + "</span>";
      if (minusEl) minusEl.innerHTML = "<span>" + newScore.minus + "</span>";
    }
  }

  // =========================
  // 5- SHORT LINK COPY (button)
  // =========================
  const input = document.getElementById("short-l-copy");

  if (input) {
    input.addEventListener("click", function (e) {
      e.stopPropagation();

      input.focus();
      input.select();

      document.execCommand("copy");

      const copied = document.querySelector(".copied");
      if (copied) {
        copied.style.display = "block";
        setTimeout(() => {
          copied.style.display = "none";
        }, 1500);
      }
    });
  }

  // =========================
  // 6- TAB SYSTEM
  // =========================
  const tabItems = document.querySelectorAll(".tab_header_title");
  const tabContents = document.querySelectorAll(".context");

  tabItems.forEach((tab, i) => {
    tab.addEventListener("click", () => {
      tabContents.forEach((c) => c.classList.remove("active"));
      tabItems.forEach((t) => t.classList.remove("active"));

      tabContents[i]?.classList.add("active");
      tab.classList.add("active");
    });
  });

});